import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const CompanyLogoQuery = graphql(/* GraphQL */ `
  query companyLogo {
    logoUrl
  }
`);
